var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "w-full transition-all duration-300" }, [
    _vm.period.is_booked === false
      ? _c(
          "div",
          {
            staticClass:
              "w-full border rounded px-1.5 flex flex-col justify-center gap-1 transition-all duration-300 cursor-pointer",
            class: {
              "pt-4": _vm.isFirst,
              "pointer-events-none": !_vm.currentUser.role.includes("admin"),
              "hover:bg-hover-state": !_vm.isSelected
            },
            style: {
              backgroundColor: _vm.period.element.backgroundColor,
              borderColor: _vm.period.element.borderColor,
              height: _vm.period.element.height
            },
            attrs: { title: "Make appointment" },
            on: { click: _vm.onMakeAppointment }
          },
          [
            _c("BlTextBody2", {
              staticClass: "transition-all duration-300",
              style: { color: _vm.period.element.color },
              attrs: {
                text:
                  _vm.period.start_time_string +
                  " - " +
                  _vm.period.end_time_string
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.period.is_booked
      ? _c(
          "div",
          {
            staticClass:
              "relative border rounded px-1.5 transition-all duration-300",
            class: {
              "pt-4": _vm.isFirst,
              "border-dashed":
                _vm.period.appointment.status === "booking_in_progress"
            },
            style: {
              backgroundColor: _vm.period.element.backgroundColor,
              borderColor: _vm.period.element.borderColor,
              height: _vm.period.element.height
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "h-full flex gap-1",
                class: {
                  "items-center justify-between":
                    _vm.isCompact && _vm.period.count === 1,
                  "flex-col justify-center":
                    !_vm.isCompact || _vm.period.count > 1
                }
              },
              [
                _vm.isOpenRoom &&
                _vm.period.appointment.user &&
                _vm.period.appointment.user.name &&
                (!_vm.isCompact || _vm.period.count > 1)
                  ? _c("BlTextBody2", {
                      staticClass: "truncate",
                      style: { color: _vm.period.element.color },
                      attrs: { text: _vm.period.appointment.user.name }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.period.appointment.client &&
                _vm.period.appointment.client.name
                  ? _c("BlTextSubtitle3", {
                      staticClass: "truncate",
                      style: { color: _vm.period.element.color },
                      attrs: { text: _vm.period.appointment.client.name }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.isCompact && _vm.period.count === 1
                  ? _c("BlTextBody2", {
                      style: { color: _vm.period.element.color },
                      attrs: { text: _vm.period.appointment.start_time_string }
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isCompact || _vm.period.count > 1
                  ? _c("BlTextBody2", {
                      style: { color: _vm.period.element.color },
                      attrs: {
                        text:
                          _vm.period.appointment.start_time_string +
                          " - " +
                          _vm.period.appointment.end_time_string
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isCompact &&
                _vm.enableBranch &&
                _vm.period.appointment.room.branch
                  ? _c("BlTextBody2", {
                      staticClass: "truncate",
                      style: { color: _vm.period.element.color },
                      attrs: { text: _vm.period.appointment.room.branch.name }
                    })
                  : _vm._e()
              ],
              1
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-596e4fdb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-596e4fdb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointments/overlay/Period.vue
// module id = null
// module chunks = 